import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import QueryString from 'qs';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { ClipLoader } from 'react-spinners';
import moment from 'moment/moment';
import TableWithHeadingAndSearch from '../../components/Table/TableWithHeadingAndSearch';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import ExportProductModal from './ExportProductModal';

const ViewIndiaMartLeads = () => {
    const [page, setPage] = useState(1);
    const [totalDocs, setTotalDocs] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [openExportProductModal, setOpenExportProductModal] = useState(false);
    const [leads, setLeads] = useState({});

    // const fetchIndiaMartLeads = async(start = null, end = null)=>{
    //     try {
    //         setIsLoading(true);
    //         const query = {}
    //         if(start ){
    //             query['startTime'] = start
    //         }
    //         if(end){
    //             query['endTime'] = end
    //         }
    //         const string = QueryString.stringify(query);
    //         const resp = await authAxiosInstance.get(
    //             `/indiamart?${string}`
    //         )
    //         console.log('resp', resp)

    //         setIsLoading(false);
    //     } catch (error) {
    //         console.log('error',error)
    //     } finally {
    //         setIsLoading(false)
    //     }
    // }

    const getIndiaMartLeads = async (restQuery = {}, search = null, ) => {
        try {
            setIsLoading(true);
            const query = { page, search, ...restQuery };
            const string = QueryString.stringify(query);
            const resp = await authAxiosInstance.get(
                `/indiamart/getLeads?${string}`
            );
            const data = resp?.data?.data
            setLeads(data);
            setTotalDocs(data?.totalDocs)

            return data
        } catch (error) {
            console.log('error', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // const startDate = moment().subtract(7,'days').valueOf();
        // const endDate = moment().valueOf();
        // fetchIndiaMartLeads(startDate,endDate);
        getIndiaMartLeads();
    }, [page]);

    const cols = [
        {
            Header: 'Sr.No.',
            Cell: ({ row }) => {
                return <div>{(page - 1) * 100 + row?.index + 1}.</div>;
            },
        },
        {
            Header: 'Date & Time',
            Cell: ({ row }) => {
                const momentDate = moment(row?.original?.time);
                return (
                    <div>
                        {momentDate.format('DD-MMM-YYYY') +
                            ', ' +
                            momentDate.format('hh:mm:ss a')}
                    </div>
                );
            },
        },
        {
            Header: 'Unique Id',
            accessor: 'uniqueid',
        },
        {
            Header: 'Type',
            accessor: 'type',
        },
        {
            Header: 'Sender Name',
            accessor: 'name',
        },
        {
            Header: 'Sender Mobile',
            accessor: 'mobile',
        },
        {
            Header: 'Sender Email',
            accessor: 'email',
        },
        {
            Header: 'Sender Phone',
            accessor: 'phone',
        },
        {
            Header: 'Subject',
            accessor: 'subject',
            Cell: ({ row }) => {
                return (
                    <div className="w-full text-wrap">
                        {row?.original?.subject}
                    </div>
                );
            },
        },
        {
            Header: 'Product Name',
            accessor: 'productName',
            Cell: ({ row }) => {
                return (
                    <div className="w-full text-wrap">
                        {row?.original?.productName}
                    </div>
                );
            },
        },
        {
            Header: 'Company',
            accessor: 'company',
        },
        {
            Header: 'City',
            accessor: 'city',
        },
        {
            Header: 'Address',
            Cell: ({ row }) => {
                return (
                    <div className="w-full text-wrap">
                        {row?.original?.address}
                    </div>
                );
            },
        },
        {
            Header: 'Message',
            Cell: ({ row }) => {
                return (
                    <div className="w-[500px] text-wrap">
                        {row?.original?.message}
                    </div>
                );
            },
        },
    ];

    const leadsData = useMemo(() => {
        if (leads && leads?.docs?.length > 0) return leads?.docs;
        else return [];
    }, [leads]);

    const debounceSearch = useCallback(
        _.debounce(async (search) => {
            console.log('search value', search);
            getIndiaMartLeads(search);
        }, 500),
        [page]
    );
    const calculateExportButtons = (totalDocs, gap) => {
        let result = [];
        if (totalDocs < gap) {
            const smallRange = [1, totalDocs]
            result = [smallRange];
            return result;
        }
        for (let i = 0; i <= Math.floor(totalDocs / gap); i++) {
            result.push([i * gap + 1, Math.min((i + 1) * gap, totalDocs)]);
        }
        console.log('result for loop', result);
        return result;
    };
    const BUTTON_GAP = 3000;

    return (
        <PageWithCard heading="View IndiaMart Leads">
            <ExportProductModal 
                openExportProductModal={openExportProductModal}
                setOpenExportProductModal={setOpenExportProductModal}
                totalDocs={totalDocs}
                calculateExportButtons={calculateExportButtons}
                getIndiaMartLeads={getIndiaMartLeads}
                gap={BUTTON_GAP}
                setTotalDocs={setTotalDocs}
            />
            
            <div className='my-4'>

            <PrimaryButton
                className="cursor-pointer "
                onClick={(e) => {
                    e.stopPropagation();
                    setOpenExportProductModal(true)
                }}
            >
                Export Leads
            </PrimaryButton>
            </div>
            
            <div>
                <TableWithHeadingAndGlobalSearch
                    columns={cols}
                    data={leadsData}
                    loading={isLoading}
                    searchFunction={debounceSearch}
                />
                <PaginationClassic
                    paginationDetails={leads}
                    setPage={setPage}
                />
            </div>
        </PageWithCard>
    );
};

export default ViewIndiaMartLeads;
